<template>
    <v-container>
        <v-row>
            <v-col md="12" class="pa-6 text-left text-justify">
                <div class="my-6">
                    <p class="text-h4 text--primary">
                        <TextHeading :level=3>Nasze Realizacje</TextHeading>
                    </p>
                    <span v-for="(paragraph, i) in paragraphs"
                        :key="i">
                        <p class="text--primary">
                            <TextHeading :level=5>{{ paragraph.title }}</TextHeading>
                        </p>
                        <span v-for="(section, j) in paragraph.sections" :key="j">
                            <div v-if="section.type == 'paragraph'" class="text-body-1 text--primary" v-html="section.text"></div>
                            <p v-if="section.type == 'special_paragraph'" class="text--primary">
                                <TextHeading :level=6>{{ section.text }}</TextHeading>
                            </p>
                            <span v-if="section.type == 'list'">
                                <div class="text-body-1 text--primary" v-html="section.text"></div>
                                <v-list dense disabled>
                                    <v-list-item
                                        v-for="(point, k) in section.points"
                                        :key="k"
                                    >
                                        <v-list-item-icon>
                                            <v-icon>{{ section.icon }}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title><span v-html="point"></span></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </span>
                            
                            <br />
                        </span>
                    </span>
                    <contact-form />
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import TextHeading from "@/modules/TextHeading";
import ContactForm from "@/modules/forms/ContactForm";
export default {

components: {TextHeading, ContactForm},

data: () => ({
    paragraphs: [
        {
            title: "",
            sections: [
                {
                    text: "<b>Zasada podstawowa:</b>",
                    type: "paragraph"
                },
                {
                    text: 'O tym, że warto z nami współpracować przekonali się nasi dotychczasowi Klienci <a href="/our_projects/main">NASZE REALIZACJE</a>. Firma nasza wybrała, jako jedna z niewielu spośród funkcjonujących w branży na rynku, model kompleksowej obsługi każdego projektu. Jeżeli przygotowujemy projekt, to odpowiadamy nie tylko za uzyskanie dofinansowania ale również za jego rozliczenie - aż do momentu kiedy projekt zostanie skontrolowany prze Instytucję Zarządzającą lub Pośredniczącą. ',
                    type: "paragraph"
                },
                {
                    text: "<b>Zasady współpracy z naszymi Klientami:</b>",
                    type: "paragraph"
                },
                {
                    text: "Rozliczenia z naszymi Klientami są realizowane zgodnie z zawartą umową i podzielone są na następujące etapy:",
                    type: "paragraph"
                },
                {
                    text: "Etap 1 - przygotowanie wniosku o dofinansowanie wraz z załącznikami;",
                    type: "paragraph"
                },
                {
                    text: "Etap 2 - złożenie wniosku do Instytucji organizującej konkurs (IZ/IP);",
                    type: "paragraph"
                },
                {
                    text: "Etap 3 - podpisanie umowy o dofinansowanie;",
                    type: "paragraph"
                },
                {
                    text: "Etap 4 - zakończenie realizacji inwestycji i uzyskanie ostatniej transzy przez Klienta.",
                    type: "paragraph"
                },
                {
                    text: "Jeżeli jesteście Państwo zainteresowani szczegółami współpracy, zachęcamy do kontaktu:",
                    type: "paragraph"
                },
            ]
        },
    ]
    })
}
</script>